export interface IndependentRecruiter {
  name: string
  initials: string
  specialty: string
  region: string
}

export const independentRecruiters: IndependentRecruiter[] = [
  {
    name: 'Karen Whitfield',
    initials: 'KW',
    specialty: 'Financial Services',
    region: 'New York, NY',
  },
  {
    name: 'Daniel Reyes',
    initials: 'DR',
    specialty: 'Software Engineering',
    region: 'Austin, TX',
  },
  {
    name: 'Monica Feldman',
    initials: 'MF',
    specialty: 'Healthcare Leadership',
    region: 'Boston, MA',
  },
  {
    name: 'Terrence Boyle',
    initials: 'TB',
    specialty: 'Manufacturing & Operations',
    region: 'Cleveland, OH',
  },
  {
    name: 'Aisha Bello',
    initials: 'AB',
    specialty: 'Pharmaceutical & Biotech',
    region: 'Raleigh, NC',
  },
  {
    name: 'Gregory Lin',
    initials: 'GL',
    specialty: 'Data & Analytics',
    region: 'Seattle, WA',
  },
  {
    name: 'Patricia Nolan',
    initials: 'PN',
    specialty: 'Human Resources',
    region: 'Chicago, IL',
  },
  {
    name: 'Victor Almeida',
    initials: 'VA',
    specialty: 'Supply Chain & Logistics',
    region: 'Miami, FL',
  },
  {
    name: 'Rachel Steinberg',
    initials: 'RS',
    specialty: 'Legal & Compliance',
    region: 'Washington, DC',
  },
  {
    name: 'Marcus Devine',
    initials: 'MD',
    specialty: 'Private Equity Portfolio',
    region: 'Greenwich, CT',
  },
  {
    name: 'Helen Okafor',
    initials: 'HO',
    specialty: 'Nonprofit & Education',
    region: 'Atlanta, GA',
  },
  {
    name: 'Jonathan Pruitt',
    initials: 'JP',
    specialty: 'Energy & Utilities',
    region: 'Houston, TX',
  },
  {
    name: 'Sofia Marchetti',
    initials: 'SM',
    specialty: 'Luxury Retail & Consumer',
    region: 'Los Angeles, CA',
  },
  {
    name: 'Andre Coleman',
    initials: 'AC',
    specialty: 'Construction & Real Estate',
    region: 'Denver, CO',
  },
  {
    name: 'Priya Raghavan',
    initials: 'PR',
    specialty: 'Cybersecurity',
    region: 'San Jose, CA',
  },
  {
    name: 'Nathan Brooks',
    initials: 'NB',
    specialty: 'Insurance & Risk',
    region: 'Hartford, CT',
  },
  {
    name: 'Elena Vasquez',
    initials: 'EV',
    specialty: 'Marketing & Brand',
    region: 'Phoenix, AZ',
  },
  {
    name: 'Christopher Doyle',
    initials: 'CD',
    specialty: 'Aerospace & Defense',
    region: 'Huntsville, AL',
  },
  {
    name: 'Yvette Laurent',
    initials: 'YL',
    specialty: 'Hospitality & Gaming',
    region: 'Las Vegas, NV',
  },
  {
    name: 'Samuel Adeyemi',
    initials: 'SA',
    specialty: 'Telecommunications',
    region: 'Dallas, TX',
  },
]
